import { z } from 'zod';
/**
 * Contract for `internal.worker_heartbeats.processing_settings` — STORY-077,
 * track-transitions arch §2.4.
 *
 * The worker writes, at every heartbeat, what it processes tracks with: whether
 * it builds trimmed copies, whether it keeps the untrimmed ones, and `params`,
 * the analysis settings exactly as every analysis it records stores them. Its
 * backfill planner selects work with the same values, so the api counts the
 * catalogue re-processing with them (`content.track_backfill_counts`) and the
 * two never disagree. The writer is a separate deployable, so the api parses
 * the column with this schema; NULL, or no fresh heartbeat, means unknown —
 * never zero.
 */
export const workerProcessingSettingsSchema = z
    .object({
    trimming_enabled: z.boolean(),
    untrimmed_keep: z.boolean(),
    params: z.record(z.string(), z.number()),
})
    .strip();
//# sourceMappingURL=worker-processing-settings.js.map